export const PAYROLL_SETTINGS_PATH = "/payroll-settings";
export const PAYROLL_SETTINGS_ROSTER_PATH = `${PAYROLL_SETTINGS_PATH}/roster`;

export const isPayrollSettingsPath = (pathname: string) => {
  const afterPath = pathname.slice(PAYROLL_SETTINGS_PATH.length);
  return (
    pathname.startsWith(PAYROLL_SETTINGS_PATH) &&
    (afterPath === "" || afterPath.startsWith("/"))
  );
};

// The rules editor is its own working surface, not a Settings pane: Settings is
// where the roster lives, and the two are used in completely different sittings.
export const PAYROLL_EDITOR_PATH = "/payroll-rules";
export const LEGACY_PAYROLL_EDITOR_PATH = `${PAYROLL_SETTINGS_PATH}/rules`;
const isUnder = (pathname: string, base: string) =>
  pathname === base || pathname.startsWith(`${base}/`);

// Covers the old Settings URL too, so a bookmark still reaches the redirect
// instead of being bounced by the roster permission check.
export const isPayrollEditorPath = (pathname: string) =>
  isUnder(pathname, PAYROLL_EDITOR_PATH) ||
  isUnder(pathname, LEGACY_PAYROLL_EDITOR_PATH);
